<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<tr>
							<!-- 전체수량 -->
							<th>{{ getMessage_('QWCC001669') }}</th>
							<td>{{ resultList.totCnt ? resultList.totCnt : 0 }}</td>
						</tr>
						<tr>
							<!-- 정상수량 -->
							<th>{{ getMessage_('QWCC001670') }}</th>
							<td>{{ resultList.normCnt ? resultList.normCnt : 0 }}</td>
						</tr>
						<tr>
							<!-- 적합/부적합 -->
							<th>{{ `${getMessage_('QWCC001671')} / ${getMessage_('QWCC001672')}` }}</th>
							<td>{{ `${resultList.okCnt ? resultList.okCnt : 0} / ${resultList.ngCnt ? resultList.ngCnt : 0}` }}</td>
						</tr>
						<tr>
							<!-- 운휴수량 -->
							<th>{{ getMessage_('QWCC001673') }}</th>
							<td>{{ resultList.stpgCnt ? resultList.stpgCnt : 0 }}</td>
						</tr>
						<tr>
							<!-- 고장수량 -->
							<th>{{ getMessage_('QWCC001674') }}</th>
							<td>{{ resultList.bkdwCnt ? resultList.bkdwCnt : 0 }}</td>
						</tr>
						<tr>
							<!-- 기타수량 -->
							<th>{{ getMessage_('QWCC001675') }}</th>
							<td>{{ resultList.etcCnt ? resultList.etcCnt : 0 }}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	methods: {
		...rootMethods,
		...serviceMethods
	},
	computed: {
		...rootComputed,
		...serviceComputed
	}
};
</script>

<style lang="scss" scoped></style>
